/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnsubscribePayload
 */
export interface UnsubscribePayload {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribePayload
     */
    option?: string;
    /**
     * 
     * @type {string}
     * @memberof UnsubscribePayload
     */
    text?: string;
}

/**
 * Check if a given object implements the UnsubscribePayload interface.
 */
export function instanceOfUnsubscribePayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UnsubscribePayloadFromJSON(json: any): UnsubscribePayload {
    return UnsubscribePayloadFromJSONTyped(json, false);
}

export function UnsubscribePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnsubscribePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'option': !exists(json, 'option') ? undefined : json['option'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function UnsubscribePayloadToJSON(value?: UnsubscribePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'option': value.option,
        'text': value.text,
    };
}

